<template>
  <page>
    <template #content>
      <SubTopBar></SubTopBar>
    <v-breadcrumbs
      :items="bcItems"
      divider=">"
      class="mt-1"
      large
      />
      <v-form v-model="valid" ref="form" class="">
      <v-row>
        <v-col cols="12" class="mb-n5">
          <v-text-field
          outlined
          dense
          :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showCurrentPassword ? 'text' : 'password'"
          v-model="currentPassword"
          label="Current password"
          @click:append="showCurrentPassword = !showCurrentPassword"
          ref="current"
          :rules="[global.rules.requiredField]"
          placeholder=" "
          />
        </v-col>
        <v-col cols="12" class="mb-n5">
          <v-text-field
            outlined
            dense
            :type="showNewPassword ? 'text' : 'password'"
            v-model="newPassword"
            label="New password"
            ref="password"
            @click:append="showNewPassword = !showNewPassword"
            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="newPassword == '' ? [global.rules.requiredField] : [global.rules.passwordField]"
            placeholder=" "
            @focus="passwordFocus = true" 
            @blur="passwordFocus = false"
            class="new-password"
          />
        </v-col>
        <passwordRules :showRules="showRules" :password="newPassword" />
        <v-col cols="12" class="mb-n5">
          <v-text-field
            outlined
            dense
            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showConfirmPassword ? 'text' : 'password'"
            v-model="confirmPassword"
            label="Confirm new password"
            ref="confirm"
            placeholder=" "
            @click:append="showConfirmPassword = !showConfirmPassword"
            :rules="[global.rules.requiredField]"
          />
        </v-col>
        <v-col cols="12" class="mb-n5">
          <v-btn color="primary" :disabled="!valid" @click="changePasswordOnClick">Change password</v-btn>
          <v-btn text @click="close">cancel</v-btn>
        </v-col>
      </v-row>
    </v-form>
    </template>
  </page>
</template>

<script>
const Iam = require('iam')
import PasswordStrings from './PasswordStrings'
import passwordRules from "../../Utils/passwordRules.vue"
export default {
  components: {passwordRules},
  data () {
    return {
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      valid: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordFocus: false
    }
  },
  mounted() {
    if (this.$store.state.updatePassword) {
      this.alert('info', 'We have updated our password policy, Please update your password.')
    }
  },
  computed: {
    bcItems: function (){
      return [
        {},
        {
          text: "Profile",
          disabled: false,
          exact: true,
          to: {name: 'Profile'},
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]},
    isNewPassEqualConfirmPass() {
      return this.newPassword == this.confirmPassword
    },
    showRules() {
      return this.passwordFocus || (this.newPassword && !this.global.passwordRegex.test(this.newPassword))
    }
  },
  methods: {
    changePasswordOnClick: function () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.isNewPassEqualConfirmPass) {
        this.alert("error", PasswordStrings(this, "validate_password"), undefined, undefined, ()=> {
          
        })
        return
      }
      const password = new Iam.UpdatePassword()
      password.currentpassword = this.currentPassword
      password.newpassword = this.newPassword
      this.$api.updatePassword(password, this.username,this.callBack(()=> {
        this.alert("info", PasswordStrings(this, "successfully_changed"), undefined, undefined, ()=> {})
      },() => {
        this.alert("error", PasswordStrings(this, "wrong_old_password"), undefined, undefined, ()=> {
          this.$refs.current.focus()
        })
      }))
    },
  }
}
</script>
<style>
.new-password .v-text-field__details {
  display: none;
}
</style>